'use client';

import { Tag } from '@components/templates/my-jobs/Card/partials/Tag';
import { ApplicantStatus } from '@type/company-job';
import { ApiCompanyJobDetail } from '@type/v1-api-types';
import { useTranslation } from 'next-i18next';

const COMPANY_JOB_APPLICANTS_TAGS: {
  label: string;
  href: (jobSlug: string) => string;
  countKey?: string;
  className: string;
}[] = [
  {
    label: 'my-jobs.card.tags.new',
    countKey: `status_${ApplicantStatus.NEW}`,
    href: (jobSlug) => `/job/${jobSlug}/applicants/flow?board=unseen`,
    className: 'text-primary hover:bg-primary/10',
  },
  {
    label: 'my-jobs.card.tags.shortlisted',
    countKey: `status_${ApplicantStatus.SHORTLIST}`,
    href: (jobSlug) => `/job/${jobSlug}/applicants?status=${ApplicantStatus.SHORTLIST}`,
    className: 'text-secondary hover:bg-secondary/10',
  },
  {
    label: 'my-jobs.card.tags.interview',
    countKey: `status_${ApplicantStatus.INTERVIEW}`,
    href: (jobSlug) => `/job/${jobSlug}/applicants?status=${ApplicantStatus.INTERVIEW}`,
    className: 'text-pink hover:bg-pink/10',
  },
  {
    label: 'my-jobs.card.tags.all',
    countKey: 'total',
    href: (jobSlug) => `/job/${jobSlug}/applicants/flow`,
    className: 'hover:bg-[#F0F2F4] dark:hover:text-dark',
  },
];

interface ApplicantsTagsProps {
  job: ApiCompanyJobDetail;
}

export const ApplicantsTags = (props: ApplicantsTagsProps) => {
  // Destructure props
  const { job } = props;

  // Translation
  const { t } = useTranslation('common');

  if (!job.applicationStats) return null;

  return (
    <div className="pt-8">
      <div className="mb-5 flex items-center justify-between">
        <h3 className="text-lg font-bold">
          {t('job.detail.company.applicants.title')}
        </h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {COMPANY_JOB_APPLICANTS_TAGS.map((tag) => (
          <Tag
            key={tag.label}
            {...tag}
            label={t(tag.label)}
            href={tag.href(job.slug)}
            count={
              tag.countKey ? job.applicationStats?.[tag.countKey] : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};
